





















































































import { Catalog } from "@/graphql/client";
import { Component, Ref, Emit, Mixins } from "vue-property-decorator";
import catalogService from "@/service/catalogService";
import ProgressLinear from "@/components/molecules/ProgressLinear.vue";
import MixinFormatter from "@/components/mixins/MixinFormatter.vue";
import MixinValidator from "@/components/mixins/catalog/MixinCatalogEditDialogValidator.vue";
import moment from "moment";

@Component({
  components: {
    ProgressLinear,
  },
})
export default class CatalogEditDialog extends Mixins(
  MixinFormatter,
  MixinValidator
) {
  @Ref() readonly itemForm!: HTMLFormElement;
  //---------------------------
  // data
  //---------------------------
  isOpen = false;
  isProgressing = false;
  item: Catalog = catalogService.defaultCatalog;
  valid = false;
  //---------------------------
  // mounted
  //---------------------------
  //---------------------------
  // computed
  //---------------------------
  /**
   * 「YYY-MM-DD HH:mm:ss」形式の登録日時を取得
   */
  get formattedCreatedAt(): string {
    return this.item.createdAt
      ? moment(this.item.createdAt).format("YYYY-MM-DD HH:mm:ss")
      : "";
  }
  /**
   * 「YYY-MM-DD HH:mm:ss」形式の更新日時を取得
   */
  get formattedUpdatedAt(): string {
    return this.item.updatedAt
      ? moment(this.item.updatedAt).format("YYYY-MM-DD HH:mm:ss")
      : "";
  }
  //---------------------------
  // methods
  //---------------------------
  async fetchData(item: Catalog): Promise<void> {
    this.item = catalogService.defaultCatalog;
    if (item.guid) {
      const cat = await catalogService.getCatalog(item.guid);
      if (cat) {
        this.item = cat;
      }
    }
  }
  /**
   * ダイアログを表示します.
   */
  public async open(item: Catalog): Promise<void> {
    await this.fetchData(item);

    this.isProgressing = false;
    this.isOpen = true;
  }

  /**
   * ダイアログを閉じます.
   */
  public close(): void {
    this.$v.$reset();
    this.isProgressing = false;
    this.isOpen = false;
  }

  /**
   * 入力内容を保存します.
   */
  save(): void {
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.isProgressing = true;
      if (this.item.guid) {
        //update
        catalogService
          .updateCatalog(this.item)
          .then((result) => {
            this.isProgressing = false;
            this.notifyUpdateSuccess(result as Catalog);
          })
          .catch((err) => {
            console.error(err);
            this.notifyError("カタログの更新ができませんでした.");
          });
      } else {
        //create
        catalogService
          .createCatalog(this.item)
          .then((result) => {
            this.isProgressing = false;
            this.notifyCreateSuccess(result as Catalog);
          })
          .catch((err) => {
            console.error(err);
            this.notifyError("カタログの登録ができませんでした.");
          });
      }
    }
  }

  /**
   * 登録成功
   */
  @Emit("onCreateSuccess")
  public notifyCreateSuccess(created: Catalog): Catalog {
    return created;
  }
  /**
   * 更新成功
   */
  @Emit("onUpdateSuccess")
  public notifyUpdateSuccess(updated: Catalog): Catalog {
    return updated;
  }
  /**
   * 失敗
   */
  @Emit("onError")
  public notifyError(message: string): string {
    return message;
  }
}
